// Faza 6.2.23 (2026-05-03): split z customers.ts — see .plans/audit-customers-split.md
// Sesja 3.5 (2026-05-03): migracja na Nanostores dla customers state

import { $customersList } from '../../stores/customers.js';
import type { CustomerRow, CustomerOrderSummary, ApiError } from '../../types/dto.ts';
import { showConfirm } from '../sb-dialogs.ts';
import { formatLocalDateShortPL } from '../_datetime.ts';

// `state` (proxy do window.__sbState) zostaje — tu już nie używany do __sbState pól,
// ale __sbStateExt._modalUrlRestore (utility/cache) NIE jest migrowany.
// @ts-ignore TS6133 — zachowane dla parytetu z legacy (BATCH 3 strict migration)
var state = (typeof window !== 'undefined' && window.__sbState) || (function() {
  var _p = new Proxy({}, {
    get: function(_, k) { return window.__sbState ? window.__sbState[k as any] : undefined; },
    set: function(_, k, v) { if (window.__sbState) window.__sbState[k as any] = v; return true; },
    has: function(_, k) { return window.__sbState ? (k in window.__sbState) : false; },
  });
  return _p;
})();


// Lazy delegates (Faza 6.2.23 — cross-module deps)
function normalizeStatusLabel(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.normalizeStatusLabel) || window.normalizeStatusLabel) as any).apply(this, args); }
// AUDYT 2026-08-11: mutacja z modala musi zgasić cache liczników + auto-cache listy klientów
function _odswiezKlientowPoMutacji() { try { var f = (window as any).__sbOdswiezKlientow; if (typeof f === 'function') f(); } catch (_e) {} }
function showOrderDetail(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.showOrderDetail) || window.showOrderDetail) as any).apply(this, args); }
function statusColorForLabel(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.statusColorForLabel) || window.statusColorForLabel) as any).apply(this, args); }
function closeModal(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.closeModal) || window.closeModal) as any).apply(this, args); }
function navigate(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.navigate) || window.navigate) as any).apply(this, args); }
function openModal(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.openModal) || window.openModal) as any).apply(this, args); }

// Cross-file delegates (Faza 6.2.23 — między customers/* files)
function groupCustomersByDupes(this: any, ...args: any[]): any { return (((window.__sbExports && window.__sbExports.groupCustomersByDupes) || window.groupCustomersByDupes) as any).apply(this, args); }


async function openCustomerModal(customerId: string | number) {
    var modalCard = document.getElementById('modal-card');
    openModal('', '<div style="text-align:center;padding:60px 0"><span style="color:var(--color-text-muted);font-size:13px">Ładowanie klienta...</span></div>', '', true);
    if (modalCard) modalCard.style.maxWidth = '980px';
    // Update URL — enables sharing / direct link
    if (!(window.__sbStateExt as any)._modalUrlRestore) (window.__sbStateExt as any)._modalUrlRestore = window.location.pathname + window.location.search;
    history.replaceState(null, '', '/customers/' + encodeURIComponent(customerId));

    var customer: CustomerRow = null as unknown as CustomerRow;
    try {
      customer = await SellBaseAPI.getCustomer(customerId);
    } catch (e: any) {
      var msg = String((e && (e as any).message) || '');
      var bodyEl = document.getElementById('modal-body');
      if (bodyEl) bodyEl.innerHTML = '<div style="padding:40px;text-align:center;color:var(--color-error)">Nie udało się pobrać klienta: ' + escapeHtml(msg || 'Błąd API') + '</div>';
      return;
    }

    var statusObj = SellBaseData.getCustomerStatusObj(customer.status);
    var isCompany = customer.type === 'company';
    var displayName = isCompany
      ? (customer.company_name || (customer.first_name + ' ' + customer.last_name))
      : (customer.first_name + ' ' + customer.last_name);
    var countryLabels = SellBaseData.countryLabels;
    var formattedReg = formatLocalDateShortPL(customer.created_at) || '\u2014';
    var customerOrders = Array.isArray(customer.orders_history) ? customer.orders_history : [];
    // Znajdź duplikaty z załadowanej listy klientów (do przycisków Scal)
    var modalDupes: CustomerRow[] = [];
    try {
      var _tmpList = $customersList.get();
      if (_tmpList && _tmpList.length > 0) {
        var _tmpGrps = groupCustomersByDupes(_tmpList);
        _tmpGrps.forEach(function(g: CustomerRow[]) {
          if (g.some(function(c: CustomerRow) { return c.id === customerId; })) {
            modalDupes = g.filter(function(c: CustomerRow) { return c.id !== customerId; });
          }
        });
      }
    } catch (_ge: any) {}

    // Mapa email → dupeId (do przycisków Scal przy emailach)
    var _emailToDupeId = {};
    modalDupes.forEach(function(d: CustomerRow) {
      if (d.email) (_emailToDupeId as any)[d.email.toLowerCase()] = d.id;
    });

    // Wszystkie unikalne emaile z historii zamówień + z duplikatów (poza głównym)
    var _otherEmailsSet = new Set<string>();
    customerOrders.forEach(function(o: CustomerOrderSummary) {
      var e = (String(o.buyer_email || '')).toLowerCase();
      if (e && e !== (customer.email || '').toLowerCase()) _otherEmailsSet.add(String(o.buyer_email));
    });
    modalDupes.forEach(function(d: CustomerRow) {
      if (d.email && d.email.toLowerCase() !== (customer.email || '').toLowerCase()) _otherEmailsSet.add(d.email);
    });
    var otherEmailsList = Array.from(_otherEmailsSet);

    // Wszystkie unikalne adresy z historii zamówień + z duplikatów (poza głównym)
    var _addrSet = new Set();
    var _otherAddrsList: string[] = [];
    var _primaryAddrKey = ((customer.delivery_postal_code || '') + '|' + (customer.delivery_city || '')).toLowerCase();
    if (_primaryAddrKey !== '|') _addrSet.add(_primaryAddrKey);
    function _tryAddAddr(postal: string | undefined, city: string | undefined, street: string | undefined, country: string | undefined) {
      var key = ((postal || '') + '|' + (city || '')).toLowerCase();
      if (!key || key === '|' || _addrSet.has(key)) return;
      _addrSet.add(key);
      var parts = [street, postal && city ? postal + ' ' + city : (city || postal)].filter(Boolean);
      var cc = (country || '').toUpperCase();
      var countryTxt = cc ? ((countryLabels && countryLabels[cc]) || cc) : '';
      var countryPart = countryTxt ? ' <span style="color:var(--color-text-muted);font-size:0.85em">(' + escapeHtml(countryTxt) + ')</span>' : '';
      _otherAddrsList.push(escapeHtml(parts.join(', ')) + countryPart);
    }
    customerOrders.forEach(function(o: CustomerOrderSummary) {
      _tryAddAddr(o.delivery_postal_code as string | undefined, o.delivery_city as string | undefined, o.delivery_street as string | undefined, o.delivery_country as string | undefined);
    });
    modalDupes.forEach(function(d: CustomerRow) {
      _tryAddAddr(d.delivery_postal_code, d.delivery_city, d.delivery_street, d.delivery_country);
    });
    var addrCount = _addrSet.size;
    var typeBadgeColor = isCompany ? '#3b82f6' : '#8b5cf6';
    var typeIcon = isCompany ? 'building-2' : 'user';
    var typeLabel = isCompany ? 'Firma' : 'Osoba';

    // ── Inline edit state ─────────────────────────────────────────────────
    var _cmDirty = {};
    var _cmOrigVals = {};

    // Creates an editable span; registers original value for dirty tracking
    function mkEdit(field: string, origVal: unknown, displayHtml?: string, inputType?: string) {
      (_cmOrigVals as any)[field] = origVal !== undefined ? origVal : '';
      var show = displayHtml !== undefined ? displayHtml
        : (escapeHtml(String(origVal || '')) || '<span style="color:var(--color-text-muted);font-size:0.85em">—</span>');
      return '<span class="cm-editable" data-edit-field="' + escapeAttr(field) + '" data-edit-type="' + (inputType || 'text') + '" title="Kliknij aby edytować">' + show + '</span>';
    }

    // Full grid row: label + editable value cell
    function editRow(label: string, field: string, origVal: unknown, displayHtml?: string, inputType?: string) {
      (_cmOrigVals as any)[field] = origVal !== undefined ? origVal : '';
      var show = displayHtml !== undefined ? displayHtml
        : (escapeHtml(String(origVal || '')) || '<span style="color:var(--color-text-muted)">—</span>');
      return '<span style="color:var(--color-text-muted);font-size:0.85em;align-self:start;padding-top:1px">' + label + '</span>' +
        '<span class="cm-editable" data-edit-field="' + escapeAttr(field) + '" data-edit-type="' + (inputType || 'text') + '" style="font-size:0.9em" title="Kliknij aby edytować">' + show + '</span>';
    }

    // Address block with per-field editable spans
    function addrBlockEdit(prefix: string) {
      var name     = customer[prefix + '_name'] || '';
      var company  = customer[prefix + '_company'] || '';
      var street   = customer[prefix + '_street'] || '';
      var postal   = customer[prefix + '_postal_code'] || '';
      var city     = customer[prefix + '_city'] || '';
      var province = customer[prefix + '_province'] || '';
      var country  = String(customer[prefix + '_country'] || '');
      var nip      = customer[prefix + '_nip'] || '';
      var showComp = company && company !== name && company !== (customer.company_name || '');
      var countryName = country ? ((countryLabels && countryLabels[country.toUpperCase()]) || country.toUpperCase()) : '';
      var lines = [];
      if (name)     lines.push(mkEdit(prefix + '_name', name));
      if (showComp) lines.push('<em>' + mkEdit(prefix + '_company', company) + '</em>');
      lines.push(mkEdit(prefix + '_street', street));
      lines.push(mkEdit(prefix + '_postal_code', postal) + '\u00a0' + mkEdit(prefix + '_city', city));
      if (province) lines.push(mkEdit(prefix + '_province', province));
      lines.push(mkEdit(prefix + '_country', country,
        '<span style="color:var(--color-text-muted);font-size:0.85em">' + escapeHtml(countryName || '\u2014') + '</span>',
        'select-country'));
      if (nip) lines.push('<span style="color:var(--color-text-muted)">NIP: ' + mkEdit(prefix + '_nip', nip) + '</span>');
      return lines.length ? lines.join('<br>') : '<span style="color:var(--color-text-muted)">\u2014</span>';
    }

    // Helper: render info row pair (spans directly into display:grid parent)
    function infoRow(label: string, valueHtml: string) {
      if (!valueHtml) return '';
      return '<span style="color:var(--color-text-muted);font-size:0.85em;align-self:start;padding-top:1px">' + label + '</span>' +
             '<span style="font-size:0.9em">' + valueHtml + '</span>';
    }

    // Helper: format address block as plain text lines
    // @ts-ignore TS6133 — zachowane dla parytetu z legacy (BATCH 3 strict migration)
    function addrBlock(prefix: string) {
      var name     = customer[prefix + '_name'] || '';
      var company  = customer[prefix + '_company'] || '';
      var street   = customer[prefix + '_street'] || '';
      var postal   = customer[prefix + '_postal_code'] || '';
      var city     = customer[prefix + '_city'] || '';
      var province = customer[prefix + '_province'] || '';
      var country  = String(customer[prefix + '_country'] || '');
      var nip      = customer[prefix + '_nip'] || '';
      // Pokaż firmę tylko gdy różni się od name i od głównej nazwy firmy klienta
      var showCompany = company && company !== name && company !== (customer.company_name || '');
      var lines = [];
      if (name)            lines.push(escapeHtml(name));
      if (showCompany)     lines.push('<em>' + escapeHtml(company) + '</em>');
      if (street)          lines.push(escapeHtml(street));
      if (postal || city)  lines.push(escapeHtml((postal + ' ' + city).trim()));
      if (province)        lines.push(escapeHtml(province));
      // Kraj — zawsze pokazuj nazwę pod kodem pocztowym
      if (country) {
        var countryName = (countryLabels && countryLabels[country.toUpperCase()]) || country.toUpperCase();
        lines.push('<span style="color:var(--color-text-muted);font-size:0.85em">' + escapeHtml(countryName) + '</span>');
      }
      if (nip)             lines.push('<span style="color:var(--color-text-muted)">NIP: ' + escapeHtml(nip) + '</span>');
      return lines.length ? lines.join('<br>') : '<span style="color:var(--color-text-muted)">\u2014</span>';
    }

    // Orders rows
    var ordersHtml = '';
    if (customerOrders.length > 0) {
      customerOrders.forEach(function(o: CustomerOrderSummary) {
        var orderLabel = normalizeStatusLabel(o.status || '');
        var orderColor = statusColorForLabel(orderLabel);
        var products = Array.isArray(o.products) ? o.products : [];
        ordersHtml += '<tr style="cursor:pointer" data-order-id="' + o.id + '">' +
          '<td style="font-weight:500">' + escapeHtml(String(o.id)) + '</td>' +
          '<td style="font-size:0.85em">' + escapeHtml(products.slice(0, 2).join(', ')) + (products.length > 2 ? ' +' + (products.length - 2) : '') + '</td>' +
          '<td>' + SellBaseData.formatCurrency(parseFloat(String(o.amount)) || 0, o.currency || 'PLN') + '</td>' +  // S-32 (E5): waluta zamówienia
          '<td><span class="status-badge ' + orderColor + '">' + escapeHtml(orderLabel) + '</span></td>' +
          '<td>' + escapeHtml(formatLocalDateShortPL(o.date) || String(o.date || '')) + '</td>' +
        '</tr>';
      });
    } else {
      ordersHtml = '<tr><td colspan="5" style="text-align:center;padding:24px;color:var(--color-text-muted)">Brak zam\u00f3wie\u0144</td></tr>';
    }

    var bodyHtml = '' +
      // ── Inline edit CSS ───────────────────────────────────────────────
      '<style>.cm-editable{cursor:pointer;border-radius:3px;padding:1px 4px;margin:-1px -4px;transition:background .15s;display:inline}.cm-editable:hover{background:var(--color-surface-2);outline:1px dashed var(--color-border)}.cm-editable:has(input),.cm-editable:has(select),.cm-editable:has(textarea){background:transparent!important;outline:none!important;cursor:default}</style>' +

      // ── Modal header ──────────────────────────────────────────────────
      '<div style="display:flex;align-items:center;gap:14px;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid var(--color-border)">' +
        '<div style="width:46px;height:46px;border-radius:50%;background:' + typeBadgeColor + '22;display:flex;align-items:center;justify-content:center;flex-shrink:0">' +
          '<i data-lucide="' + typeIcon + '" style="width:22px;height:22px;color:' + typeBadgeColor + '"></i>' +
        '</div>' +
        '<div style="flex:1;min-width:0">' +
          '<div style="font-size:1.1em;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + escapeHtml(displayName) + '</div>' +
          '<div style="display:flex;align-items:center;gap:8px;margin-top:5px;flex-wrap:wrap">' +
            '<span style="display:inline-flex;align-items:center;gap:4px;background:' + typeBadgeColor + '22;color:' + typeBadgeColor + ';border:1px solid ' + typeBadgeColor + '44;font-size:10px;font-weight:600;padding:2px 7px;border-radius:9999px;white-space:nowrap">' +
              '<i data-lucide="' + typeIcon + '" style="width:10px;height:10px"></i>' + typeLabel +
            '</span>' +
            '<span style="background:' + statusObj.color + ';color:#fff;font-size:10px;font-weight:600;padding:2px 8px;border-radius:9999px">' + escapeHtml(statusObj.label) + '</span>' +
            (customer.email ? '<span style="font-size:0.82em;color:var(--color-text-muted)">' + escapeHtml(customer.email) + '</span>' : '') +
            (customer.phone ? '<span style="font-size:0.82em;color:var(--color-text-muted)">' + escapeHtml(customer.phone) + '</span>' : '') +
            (addrCount > 1 ? '<span title="Zamawiał na ' + addrCount + ' różnych adresach" style="display:inline-flex;align-items:center;gap:3px;font-size:10px;font-weight:600;color:#6366f1;background:#6366f122;border:1px solid #6366f144;padding:1px 6px;border-radius:9999px;white-space:nowrap">\uD83D\uDCCD ' + addrCount + ' adresy</span>' : '') +
          '</div>' +
        '</div>' +
        '<div style="display:flex;gap:8px;flex-shrink:0">' +
          '<span style="font-size:0.78em;color:var(--color-text-muted);align-self:center;display:flex;align-items:center;gap:4px"><i data-lucide="pencil" style="width:11px;height:11px"></i> Kliknij pole aby edytować</span>' +
          '<button class="btn-ghost" id="cm-delete-btn" style="display:inline-flex;align-items:center;gap:6px;font-size:0.85em;padding:6px 12px;color:var(--color-error)">' +
            '<i data-lucide="trash-2" style="width:14px;height:14px"></i> Usu\u0144' +
          '</button>' +
        '</div>' +
      '</div>' +

      // ── 2-column info + addresses ─────────────────────────────────────
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:16px">' +

        // Left: customer info
        '<div class="table-card" style="padding:18px">' +
          '<div style="font-size:0.75em;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--color-text-muted);margin-bottom:12px;display:flex;align-items:center;gap:6px">' +
            '<i data-lucide="info" style="width:12px;height:12px"></i> Informacje' +
          '</div>' +
          '<div style="display:grid;grid-template-columns:130px 1fr;gap:6px 12px">' +
            (isCompany ? editRow('Firma', 'company_name', customer.company_name || '') : '') +
            (isCompany ? editRow('NIP', 'nip', customer.nip || '') : '') +
            '<span style="color:var(--color-text-muted);font-size:0.85em;align-self:start;padding-top:1px">Imi\u0119 i nazwisko</span>' +
            '<span style="font-size:0.9em">' + mkEdit('first_name', customer.first_name || '') + '\u00a0' + mkEdit('last_name', customer.last_name || '') + '</span>' +
            (customer.login ? infoRow('Login', escapeHtml(customer.login)) : '') +
            '<span style="color:var(--color-text-muted);font-size:0.85em;align-self:start;padding-top:1px">E-mail</span>' +
            '<span style="font-size:0.9em"><span class="cm-editable" data-edit-field="email" data-edit-type="email" title="Kliknij aby edytować">' +
              (customer.email ? '<a href="mailto:' + escapeAttr(customer.email) + '" style="color:var(--color-primary)">' + escapeHtml(customer.email) + '</a>' : '\u2014') +
            '</span>' +
            otherEmailsList.map(function(email: string) {
              var dupeId = (_emailToDupeId as any)[email.toLowerCase()];
              return '<div style="display:flex;align-items:center;gap:6px;margin-top:3px">' +
                '<span style="font-size:0.85em;color:var(--color-text-muted);word-break:break-all">' + escapeHtml(email) + '</span>' +
                (dupeId ? '<button class="cm-modal-merge-btn" data-primary-id="' + customerId + '" data-merge-id="' + dupeId + '" style="flex-shrink:0;background:none;border:1px solid #f59e0b;color:#f59e0b;border-radius:5px;font-size:10px;font-weight:600;padding:1px 7px;cursor:pointer">Scal</button>' : '') +
              '</div>';
            }).join('') + '</span>' +
            editRow('Telefon', 'phone', customer.phone || '',
              customer.phone ? '<a href="tel:' + escapeAttr(customer.phone) + '" style="color:var(--color-primary)">' + escapeHtml(customer.phone) + '</a>' : '\u2014', 'tel') +
            infoRow('Rejestracja', formattedReg) +
            editRow('Status', 'status', customer.status || 'standard',
              '<span style="background:' + statusObj.color + ';color:#fff;font-size:10px;font-weight:600;padding:2px 8px;border-radius:9999px">' + escapeHtml(statusObj.label) + '</span>',
              'select-status') +
            editRow('Notatki', 'notes', customer.notes || '',
              customer.notes ? '<em style="color:var(--color-text-muted)">' + escapeHtml(customer.notes) + '</em>'
                : '<span style="color:var(--color-text-muted);font-style:italic;font-size:0.88em">Dodaj notatk\u0119\u2026</span>', 'textarea') +
          '</div>' +
        '</div>' +

        // Right: delivery + invoice addresses
        '<div style="display:flex;flex-direction:column;gap:12px">' +
          '<div class="table-card" style="padding:16px;flex:1">' +
            '<div style="font-size:0.75em;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--color-text-muted);margin-bottom:10px;display:flex;align-items:center;gap:6px">' +
              '<i data-lucide="truck" style="width:12px;height:12px"></i> Adres dostawy' +
            '</div>' +
            '<div style="font-size:0.88em;line-height:1.85">' + addrBlockEdit('delivery') + '</div>' +
            _otherAddrsList.map(function(a: string) {
              return '<div style="margin-top:8px;padding-top:8px;border-top:1px solid var(--color-border);font-size:0.88em;line-height:1.6;color:var(--color-text-muted)">' + a + '</div>';
            }).join('') +
          '</div>' +
          '<div class="table-card" style="padding:16px;flex:1">' +
            '<div style="font-size:0.75em;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--color-text-muted);margin-bottom:10px;display:flex;align-items:center;gap:6px">' +
              '<i data-lucide="receipt" style="width:12px;height:12px"></i> Dane do faktury' +
            '</div>' +
            '<div style="font-size:0.88em;line-height:1.85">' + addrBlockEdit('invoice') + '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +

      // ── Orders history ────────────────────────────────────────────────
      '<div class="table-card">' +
        '<div style="padding:12px 16px;border-bottom:1px solid var(--color-border);display:flex;align-items:center;justify-content:space-between">' +
          '<div style="font-size:0.75em;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--color-text-muted);display:flex;align-items:center;gap:6px">' +
            '<i data-lucide="shopping-bag" style="width:12px;height:12px"></i> Historia zam\u00f3wie\u0144 (' + customerOrders.length + ')' +
          '</div>' +
          '<div style="display:flex;align-items:center;gap:16px;font-size:0.85em">' +
            '<span style="color:var(--color-text-muted)">Zam\u00f3wie\u0144: <strong style="color:var(--color-text)">' + (customer.orders || 0) + '</strong></span>' +
            '<span style="color:var(--color-text-muted)">Łącznie: <strong style="color:var(--color-primary)">' + SellBaseData.formatCurrency(customer.total || 0) + '</strong></span>' +
          '</div>' +
        '</div>' +
        '<div class="table-scroll">' +
          '<table class="data-table">' +
            '<thead><tr><th>Zam\u00f3wienie</th><th>Produkty</th><th>Warto\u015b\u0107</th><th>Status</th><th>Data</th></tr></thead>' +
            '<tbody id="cm-orders-tbody">' + ordersHtml + '</tbody>' +
          '</table>' +
        '</div>' +
      '</div>';

    var bodyEl2 = document.getElementById('modal-body');
    // @ts-ignore TS6133 — zachowane dla parytetu z legacy (BATCH 3 strict migration)
    var footerEl2 = document.getElementById('modal-footer');
    var titleEl2 = document.getElementById('modal-title');
    if (titleEl2) titleEl2.textContent = '';
    if (bodyEl2) bodyEl2.innerHTML = bodyHtml;

    // ── Footer & dirty-check helpers ──────────────────────────────────────
    var _cmCountries = [
      { code: 'PL', name: 'Polska' }, { code: 'DE', name: 'Niemcy' },
      { code: 'CZ', name: 'Czechy' }, { code: 'SK', name: 'S\u0142owacja' },
      { code: 'HU', name: 'W\u0119gry' }, { code: 'GB', name: 'Wielka Brytania' },
      { code: 'FR', name: 'Francja' }, { code: 'IT', name: 'W\u0142ochy' }
    ];
    // register email orig value (mkEdit not called for it in editRow path)
    (_cmOrigVals as any)['email'] = customer.email || '';
    (_cmOrigVals as any)['status'] = customer.status || 'standard';

    function _cmHasDirty() { return Object.keys(_cmDirty).length > 0; }

    async function _cmConfirmClose() {
      if (!_cmHasDirty()) { closeModal(); return; }
      if (await showConfirm('Zamkn\u0105\u0107 bez zapisania?', 'Masz niezapisane zmiany.', { danger: true })) closeModal();
    }

    function _cmUpdateFooter() {
      var footerEl = document.getElementById('modal-footer');
      if (!footerEl) return;
      if (_cmHasDirty()) {
        footerEl.innerHTML =
          '<button class="btn-ghost" id="cm-close-dirty">Zamknij bez zapisania</button>' +
          '<button class="btn-primary" id="cm-save-inline"><i data-lucide="check" style="width:14px;height:14px"></i> Zapisz zmiany</button>';
        lucide.createIcons();
        var closeD = document.getElementById('cm-close-dirty');
        if (closeD) closeD.addEventListener('click', async function() {
          if (await showConfirm('Zamkn\u0105\u0107 bez zapisania?', 'Zmiany w karcie klienta przepadn\u0105.', { danger: true })) closeModal();
        });
        var saveBtn = document.getElementById('cm-save-inline');
        if (saveBtn) saveBtn.addEventListener('click', async function() {
          (saveBtn as any).disabled = true;
          try {
            var updated = await SellBaseAPI.updateCustomer(customerId, _cmDirty);
            showToast('Zapisano', 'success');
            _odswiezKlientowPoMutacji();
            _cmDirty = {};
            openCustomerModal(updated && updated.id ? updated.id : customerId);
          } catch (err: any) {
            showToast((err && (err as any).message) || 'B\u0142\u0105d zapisu', 'error');
            (saveBtn as any).disabled = false;
          }
        });
      } else {
        footerEl.innerHTML = '<button class="btn-ghost" id="cm-close-clean">Zamknij</button>';
        var closeC = document.getElementById('cm-close-clean');
        if (closeC) closeC.addEventListener('click', _cmConfirmClose);
      }
    }
    _cmUpdateFooter();
    lucide.createIcons();

    // Intercept X button while dirty
    var _cmXBtn: any = document.getElementById('modal-close');
    function _cmXGuard(e: any) {
      if (_cmHasDirty()) {
        // stopImmediatePropagation MUSI p\u00f3j\u015b\u0107 synchronicznie — pytanie dopiero potem.
        e.stopImmediatePropagation();
        void (async function() {
          if (await showConfirm('Zamkn\u0105\u0107 bez zapisania?', 'Masz niezapisane zmiany.', { danger: true })) {
            _cmXBtn.removeEventListener('click', _cmXGuard, true);
            closeModal();
          }
        })();
      } else {
        _cmXBtn.removeEventListener('click', _cmXGuard, true);
      }
    }
    if (_cmXBtn) _cmXBtn.addEventListener('click', _cmXGuard, true);

    // ── Inline edit: click delegation ────────────────────────────────────
    // Usuwamy stary handler przed dodaniem nowego (unika akumulacji listenerów)
    var cmModalBody = document.getElementById('modal-body');
    if (cmModalBody) {
      if ((cmModalBody as any)._cmClickHandler) {
        cmModalBody.removeEventListener('click', (cmModalBody as any)._cmClickHandler);
        (cmModalBody as any)._cmClickHandler = null;
      }
      (cmModalBody as any)._cmClickHandler = function(e: any) {

        // Scal button
        var mergeBtn = e.target.closest('.cm-modal-merge-btn');
        if (mergeBtn) {
          var pId = mergeBtn.dataset.primaryId;
          var mId = mergeBtn.dataset.mergeId;
          mergeBtn.disabled = true;
          mergeBtn.textContent = '...';
          SellBaseAPI.mergeCustomers(pId, [mId]).then(function() {
            showToast('Scalono', 'success');
            _odswiezKlientowPoMutacji();
            openCustomerModal(pId);
          }).catch(function(err: ApiError) {
            showToast((err && err.message) || 'B\u0142\u0105d', 'error');
            mergeBtn.disabled = false;
            mergeBtn.textContent = 'Scal';
          });
          return;
        }

        // Editable span click
        var span = e.target.closest('.cm-editable');
        if (!span) return;
        // Don't re-activate if already has an input/select/textarea inside
        if (span.querySelector('input,select,textarea')) return;

        var field = span.dataset.editField;
        var editType = span.dataset.editType || 'text';
        var currentVal = String((_cmDirty as any)[field] !== undefined ? (_cmDirty as any)[field] : ((_cmOrigVals as any)[field] !== undefined ? (_cmOrigVals as any)[field] : ''));
        var origInnerHTML = span.innerHTML;

        var inputEl: any;
        var baseStyle = 'font-size:inherit;font-family:inherit;border-radius:4px;border:1px solid var(--color-primary);background:var(--color-surface);color:var(--color-text);outline:none;padding:2px 6px;box-sizing:border-box';

        if (editType === 'select-country') {
          inputEl = document.createElement('select');
          inputEl.style.cssText = baseStyle + ';cursor:pointer';
          _cmCountries.forEach(function(cn) {
            var opt = document.createElement('option');
            opt.value = cn.code;
            opt.textContent = cn.name;
            if (cn.code === currentVal) opt.selected = true;
            inputEl.appendChild(opt);
          });
        } else if (editType === 'select-status') {
          inputEl = document.createElement('select');
          inputEl.style.cssText = baseStyle + ';cursor:pointer';
          (SellBaseData.customerStatuses || []).forEach(function(s: { key?: string; label?: string; color?: string; [k: string]: unknown }) {
            var opt = document.createElement('option');
            opt.value = s.key || '';
            opt.textContent = s.label || '';
            if (s.key === currentVal) opt.selected = true;
            inputEl.appendChild(opt);
          });
        } else if (editType === 'textarea') {
          inputEl = document.createElement('textarea');
          inputEl.style.cssText = baseStyle + ';width:100%;min-height:60px;resize:vertical;display:block';
          inputEl.value = currentVal;
        } else {
          inputEl = document.createElement('input');
          inputEl.type = editType;
          inputEl.style.cssText = baseStyle + ';width:100%;max-width:220px';
          inputEl.value = currentVal;
        }

        span.innerHTML = '';
        span.appendChild(inputEl);
        inputEl.focus();
        if (inputEl.tagName === 'INPUT' && (inputEl as any).select) (inputEl as any).select();

        var _committed = false;
        function commitEdit() {
          if (_committed) return;
          _committed = true;
          var newVal = inputEl.tagName === 'SELECT' ? inputEl.value : inputEl.value;

          // Update dirty tracking
          var orig = (_cmOrigVals as any)[field] !== undefined ? (_cmOrigVals as any)[field] : '';
          if (String(newVal) !== String(orig)) {
            (_cmDirty as any)[field] = newVal;
          } else {
            delete (_cmDirty as any)[field];
          }

          // Rebuild display HTML
          var displayHtml;
          if (editType === 'select-country') {
            var selOpt = inputEl.options[inputEl.selectedIndex];
            var cn = selOpt ? selOpt.textContent : newVal;
            displayHtml = '<span style="color:var(--color-text-muted);font-size:0.85em">' + escapeHtml(cn) + '</span>';
          } else if (editType === 'select-status') {
            var selOpt2 = inputEl.options[inputEl.selectedIndex];
            var statusLabel2 = selOpt2 ? selOpt2.textContent : newVal;
            // find color
            var sObj = (SellBaseData.customerStatuses || []).find(function(s: { key?: string; color?: string; [k: string]: unknown }) { return s.key === newVal; });
            var sColor = sObj ? sObj.color : '#6b7280';
            displayHtml = '<span style="background:' + sColor + ';color:#fff;font-size:10px;font-weight:600;padding:2px 8px;border-radius:9999px">' + escapeHtml(statusLabel2) + '</span>';
          } else if (editType === 'email') {
            displayHtml = newVal
              ? '<a href="mailto:' + escapeAttr(newVal) + '" style="color:var(--color-primary)">' + escapeHtml(newVal) + '</a>'
              : '\u2014';
          } else if (editType === 'tel') {
            displayHtml = newVal
              ? '<a href="tel:' + escapeAttr(newVal) + '" style="color:var(--color-primary)">' + escapeHtml(newVal) + '</a>'
              : '\u2014';
          } else if (editType === 'textarea') {
            displayHtml = newVal
              ? '<em style="color:var(--color-text-muted)">' + escapeHtml(newVal) + '</em>'
              : '<span style="color:var(--color-text-muted);font-style:italic;font-size:0.88em">Dodaj notatk\u0119\u2026</span>';
          } else {
            displayHtml = newVal
              ? escapeHtml(newVal)
              : '<span style="color:var(--color-text-muted);font-size:0.85em">\u2014</span>';
          }
          span.innerHTML = displayHtml;
          _cmUpdateFooter();
        }

        function cancelEdit() {
          if (_committed) return;
          _committed = true;
          span.innerHTML = origInnerHTML;
        }

        inputEl.addEventListener('blur', commitEdit);
        inputEl.addEventListener('keydown', function(e2: any) {
          if ((e2 as any).key === 'Enter' && editType !== 'textarea') { e2.preventDefault(); inputEl.removeEventListener('blur', commitEdit); commitEdit(); }
          if ((e2 as any).key === 'Escape') { inputEl.removeEventListener('blur', commitEdit); cancelEdit(); }
        });
      };
      cmModalBody.addEventListener('click', (cmModalBody as any)._cmClickHandler);
    }

    // Bind order row clicks
    var cmTbody = document.getElementById('cm-orders-tbody');
    if (cmTbody) {
      cmTbody.querySelectorAll('tr[data-order-id]').forEach(function(r) {
        r.addEventListener('click', function(this: any) {
          var rawId = String(this.dataset.orderId || '');
          var routeId = rawId.indexOf('AL-') === 0 ? rawId : ('AL-' + rawId);
          closeModal();
          showOrderDetail(routeId);
        });
      });
    }

    // Delete button
    var cmDelBtn = document.getElementById('cm-delete-btn');
    if (cmDelBtn) {
      cmDelBtn.addEventListener('click', async function() {
        if (await showConfirm('Usun\u0105\u0107 klienta?', 'Klient ' + displayName + ' zniknie z listy.', { danger: true })) {
          SellBaseAPI.deleteCustomer(customer.id).then(function() {
            _cmXBtn && _cmXBtn.removeEventListener('click', _cmXGuard, true);
            closeModal();
            showToast('Klient usuni\u0119ty', 'success');
            _odswiezKlientowPoMutacji();
            navigate('/customers');
          }).catch(function(err: ApiError) {
            showToast((err && err.message) || 'Nie uda\u0142o si\u0119 usun\u0105\u0107 klienta', 'error');
          });
        }
      });
    }
}

// ── EXPOSE: extracted functions ──
(window as any).SellBaseApp = (window as any).SellBaseApp || {};
window.openCustomerModal = openCustomerModal; window.SellBaseApp.openCustomerModal = openCustomerModal;

// ── ES Module exports ──
export {
  openCustomerModal,
};
